export default function Jtb({}) {
  return (
    <a
      href="https://www.jtbstudios.com.au/digital-agency-melbourne"
      target="_blank"
      rel="noopener noreferrer"
      title="jtb"
      className="jtb text--size-xs headingStrong"
    >
      Digital Agency Melbourne
      <span className="jtb-logo">jtb</span>
    </a>
    // Web design Melbourne jtb
  );
}
